<template>
  <div class="update-section-view">
    <div class="sidebar-container" :class="{ 'sidebar-open': isSidebarOpen }">
      <Sidebar :is-open="isSidebarOpen" @toggle="toggleSidebar" />
    </div>
    
    <div class="main-content" :class="{ 'sidebar-open': isSidebarOpen }">
      <div class="header">
        <button class="back-button" @click="goBack">
          <i class="fas fa-arrow-left"></i> Back
        </button>
        <h1 class="page-title">Update Homepage Section</h1>
      </div>
      
      <div class="content-wrapper">
        <UpdateHomepageSection 
          :sectionId="sectionId" 
          @section-updated="handleSectionUpdated"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Sidebar from '@/components/Sidebar.vue';
import UpdateHomepageSection from '@/components/UpdateHomepageSection.vue';

export default {
  name: 'UpdateHomepageSectionView',
  components: {
    Sidebar,
    UpdateHomepageSection
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const isSidebarOpen = ref(false);
    
    const sectionId = computed(() => route.params.id);
    
    const toggleSidebar = () => {
      isSidebarOpen.value = !isSidebarOpen.value;
    };
    
    const goBack = () => {
      router.push('/homepage/sections');
    };
    
    const handleSectionUpdated = (section) => {
      console.log('Section updated:', section);
      // Additional logic can be added here if needed
    };
    
    return {
      sectionId,
      isSidebarOpen,
      toggleSidebar,
      goBack,
      handleSectionUpdated
    };
  }
};
</script>

<style scoped>
.update-section-view {
  display: flex;
  min-height: 100vh;
  background-color: #F3F4F6;
}

.sidebar-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 10;
  transition: all 0.3s ease;
}

.main-content {
  flex: 1;
  margin-left: 60px;
  transition: margin-left 0.3s ease;
  padding: 2rem;
}

.main-content.sidebar-open {
  margin-left: 250px;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  border: 1px solid #E5E7EB;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #4B5563;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button:hover {
  background: #F9FAFB;
  color: #1F2937;
}

.page-title {
  margin-left: 1.5rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: #1F2937;
}

.content-wrapper {
  background: transparent;
  border-radius: 12px;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    padding: 1rem;
  }
  
  .main-content.sidebar-open {
    margin-left: 0;
  }
  
  .header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .page-title {
    margin-left: 0;
  }
}
</style> 